// extracted by mini-css-extract-plugin
export var breadcrumb = "_1d-2";
export var breadcrumbArrow = "_1d-3";
export var breadcrumbs = "_1d-0";
export var link = "_1d-4";
export var small = "_1d-1";